import { queryOptions } from "@tanstack/react-query";
import type { InferRequestType, InferResponseType } from "hono/client";
import { readJson, rpc, type JsonBody, type QueryParams } from "./api";
import { queryClient } from "./session";
import { invalidate } from "./queries";

export type AttachmentView = InferResponseType<typeof rpc.api.attachments.$get>["items"][number];
export type AttachmentQuery = QueryParams<typeof rpc.api.attachments.$get>;
export const attachmentsQuery = (query: AttachmentQuery) => queryOptions({ queryKey: ["attachments", query], queryFn: () => readJson(rpc.api.attachments.$get({ query })).then(result => result.items), refetchOnWindowFocus: true });
async function refresh<T>(bookingId: string, response: Promise<T>) {
  const result = await response;
  await Promise.all([queryClient.invalidateQueries({ queryKey: ["attachments"] }), invalidate.booking(bookingId)]);
  return result;
}
export const attachmentsApi = {
  upload: (bookingId: string, form: InferRequestType<typeof rpc.api.attachments.$post>["form"]) => refresh(bookingId, readJson(rpc.api.attachments.$post({ form }))),
  patch: (bookingId: string, id: string, json: JsonBody<typeof rpc.api.attachments[":id"]["$patch"]>) => refresh(bookingId, readJson(rpc.api.attachments[":id"].$patch({ param: { id }, json }))),
  remove: (bookingId: string, id: string) => refresh(bookingId, readJson(rpc.api.attachments[":id"].$delete({ param: { id } }))),
};
